import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GeocodingService {

    constructor(
        private http: HttpClient
    ) {
    }

    reverseGeocoding(lat: number, lng: number) {
        const headers = new HttpHeaders().set('Content-Type', 'application/json').set('isWebserviceAvailableCheck', 'true');
        return this.http.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`, {headers: headers});
    }
}
